import { Injectable } from '@angular/core';

import { HttpService, NotificationService, TmsWebBaseEditService } from 'tms-lib';
import { PaymentType } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class PaymentTypeService extends TmsWebBaseEditService<PaymentType, PaymentType> {
  constructor(
    protected httpService: HttpService,
    protected notificationService: NotificationService,
  ) {
    super('PaymentType', $localize`Payment Type`, httpService, notificationService);
  }
}
